<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>费用看板</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">招聘费</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <span class="hint">默认显示近三月费用</span>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetails">
      <section class="searchBox">
        <span class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>票据：</label>
          <a-radio-group v-model="is_ticket">
            <a-radio :value="2">票据齐全</a-radio>
            <a-radio :value="1">票据不全</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>银行流水编号：</label>
          <a-radio-group v-model="is_bank_flow_num">
            <a-radio :value="2">有</a-radio>
            <a-radio :value="1">无</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status" :allowClear="true">
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="21">项目负责人驳回</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="31">财务驳回</a-select-option>
            <a-select-option :value="40">待打款/待收款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <!-- <a-select-option :value="42">已入账/已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
            <!-- <a-select-option :value="100">已作废</a-select-option> -->
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            :allowClear="true"
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo && showIsSearch">
          <label>省级项目：</label>
          <a-select
            :allowClear="true"
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-show="showIsSearch"
            :allowClear="true"
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <a-select
            :allowClear="true"
            style="width: 140px; margin-right: 6px"
            v-model="time_type"
          >
            <a-select-option :value="1">费用归属日期</a-select-option>
            <a-select-option :value="2">开票日期</a-select-option>
            <a-select-option :value="6">项目审核日期</a-select-option>
            <a-select-option :value="7">财务审核日期</a-select-option>
            <a-select-option :value="3">入账日期</a-select-option>
            <a-select-option :value="4">出账日期</a-select-option>
            <a-select-option :value="5">创建日期</a-select-option>
          </a-select>
          <a-range-picker
            v-model="date"
            @change="changeDate"
            style="width: 230px"
            :ranges="{
              今天: [moment(), moment()],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ]
            }"
            :placeholder="['开始时间', '结束时间']"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 200px"
            placeholder="费用名称|编号|金额|提交人员"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <a-button
            v-show="showIsSearch"
            class="resetStyle"
            @click="downloadCost"
          >
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0">
              <td>合计</td>
              <td></td>
              <!-- <td></td> -->
              <td></td>
              <td></td>
              <td>{{ Number(count_data.total_amount) }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                <p
                  v-if="
                    item.finance_date != undefined && item.finance_date != ''
                  "
                >
                  {{
                    item.finance_date
                      .substring(0, 10)
                      .replace("-", ".")
                      .replace("-", ".")
                  }}
                </p>
              </td>
              <td>{{ item.project_name }}</td>
              <td>
                {{
                  item.name.length > 12
                    ? item.name.substring(0, 12) + "..."
                    : item.name
                }}
              </td>
              <td>
                {{
                  item.detail.length > 15
                    ? item.detail.substring(0, 15) + "..."
                    : item.detail
                }}
              </td>
              <td>
                <p v-show="item.type == 1">
                  {{
                    "+" +
                      (Number(item.amount) + Number(item.pay_service)).toFixed(
                        2
                      )
                  }}
                </p>
                <p v-show="item.type == 2">
                  {{
                    "-" +
                      (Number(item.amount) + Number(item.pay_service)).toFixed(
                        2
                      )
                  }}
                </p>
              </td>
              <!-- <td>{{item.create_user_name}}</td> -->
              <td>
                <p v-show="item.status == 20">待项目负责人审核</p>
                <p v-show="item.status == 21">项目负责人驳回</p>
                <p v-show="item.type == 1 && item.status == 30">待开票</p>
                <p v-show="item.type == 2 && item.status == 30">待财务审核</p>
                <p v-show="item.status == 31">财务驳回</p>
                <p v-show="item.type == 1 && item.status == 40">待收款</p>
                <p v-show="item.type == 2 && item.status == 40">待付款</p>
                <p v-show="item.status == 41">出纳驳回</p>
                <p v-show="item.type == 1 && item.status == 42">已入账</p>
                <p v-show="item.type == 2 && item.status == 42">已出账</p>
                <p v-show="item.status == 50">结算完成</p>
                <p v-show="item.status == 100">费用作废</p>
              </td>
              <td class="operation">
                <a style="color: #909399" @click="detailsPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 详情 -->
    <costDetails
      v-on:hideInHandle="hideInHandle"
      v-show="isShowDetails"
      :detailsVal="detailsVal"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import costDetails from "@/components/money/costDetails"; //详情
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: {
    costDetails
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      totalPage: Number,
      thList: [
        "费用所属日期",
        // "类型",
        "项目",
        "费用名称",
        "费用明细",
        "费用总金额",
        "状态",
        "操作"
      ],
      query_field: "",
      status: "",
      type: "",
      showIsSearch: false,
      isShowDetails: false,
      detailsVal: {},
      pid: "",
      date: [
        moment()
          .month(moment().month() - 3)
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ],
      start_date: moment()
        .month(moment().month() - 3)
        .format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      time_type: 1,
      proList: [],
      project_id: "",
      company_id: [],
      customer_id: "",
      comList: [],
      finance_type_id: "",
      count_data: "",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      from_type: "",
      is_bank_flow_num: "",
      is_ticket: "",
      trade_id: "",
      showIsFlowNum: false,
      flowNumDetails: {},
      bank_flow_num: "",
      is_platform: "",
      finance_platform_id: "",
      platformList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getProOne(); //获取一级项目列表
    this.getPro(); //获取项目
  },
  watch: {
    is_platform() {
      if (this.is_platform == 1) {
        this.finance_platform_id = "";
      }
    }
  },
  methods: {
    moment,
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    detailsPage(item) {
      this.detailsVal = item;
      this.isShowDetails = true;
    },
    hideInHandle() {
      this.isShowDetails = false;
      this.reload();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    showInUserList() {
      this.isShowDetails = false;
    },
    changeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      // console.log(dateString);
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    downloadCost() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/listsRelationProjectDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&type=" +
        this.type +
        "&status=" +
        this.status +
        "&finance_type_id_pid=" +
        this.pid +
        "&finance_type_id=" +
        this.finance_type_id +
        "&time_type=" +
        this.time_type +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&project_id=" +
        pro +
        "&company_id=" +
        JSON.stringify(this.company_id) +
        "&customer_id=" +
        this.customer_id +
        "&from_type=" +
        this.from_type +
        "&is_ticket=" +
        this.is_ticket +
        "&is_bank_flow_num=" +
        this.is_bank_flow_num +
        "&trade_id=" +
        this.trade_id +
        "&finance_platform_id=" +
        this.finance_platform_id +
        "&is_platform=" +
        this.is_platform;
    },
    getData() {
      // console.log(this.$store.state.token);
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      // console.log(pro)
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance/listsRelationProject";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          type: this.type,
          status: this.status,
          finance_type_id_pid: this.pid,
          finance_type_id: this.finance_type_id,
          time_type: this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: pro,
          from_type: this.from_type,
          is_ticket: this.is_ticket,
          is_bank_flow_num: this.is_bank_flow_num,
          company_id: JSON.stringify(this.company_id),
          customer_id: this.customer_id,
          trade_id: this.trade_id,
          is_platform: this.is_platform,
          finance_platform_id: this.finance_platform_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.is_ticket = "";
      this.is_bank_flow_num = "";
      this.date = null;
      this.time_type = 1;
      this.project_id = "";
      this.company_id = [];
      this.customer_id = "";
      this.finance_type_id = "";
      this.from_type = "";
      this.type = "";
      this.pid = "";
      this.is_platform = "";
      this.finance_platform_id = "";
      this.status = "";
      this.trade_id = "";
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.getPro();
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  position: relative;
  .hint {
    position: absolute;
    right: 4%;
    top: 20px;
  }
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
  .changeTask {
    img {
      height: 16px;
    }
  }
}
</style>
